import { create } from 'zustand';

export type FunctionParam = {
    id: string;
    type: 'float' | 'String' | 'bool';
};

export type FunctionDef = {
    id: string;
    name: string;
    params: FunctionParam[];
    returnType: 'float' | 'String' | 'bool' | null;
};

interface BlockFunctionState {
    functions: FunctionDef[];
    addFunction: (fn: FunctionDef) => void;
    updateFunction: (id: string, fn: Partial<FunctionDef>) => void;
    removeFunction: (id: string) => void;
    setFunctions: (fns: FunctionDef[]) => void;
}

export const useBlockFunctionStore = create<BlockFunctionState>((set) => ({
    functions: [],
    addFunction: (fn) => set((s) => ({ functions: [...s.functions, fn] })),
    updateFunction: (id, fn) =>
        set((s) => ({ functions: s.functions.map((f) => (f.id === id ? { ...f, ...fn } : f)) })),
    removeFunction: (id) => set((s) => ({ functions: s.functions.filter((f) => f.id !== id) })),
    setFunctions: (fns) => set({ functions: fns }),
}));
